/**
 * SupportHours interface
 * Represents the hours of operation for the support line for a particular day.
 */
export enum DayOfWeek {
	MONDAY = 'monday',
	TUESDAY = 'tuesday',
	WEDNESDAY = 'wednesday',
	THURSDAY = 'thursday',
	FRIDAY = 'friday',
	SATURDAY = 'saturday',
	SUNDAY = 'sunday',
}

export interface SupportHours {
	day: DayOfWeek;

	/**
	 * The time the support line opens. Format: "8:00:00-05:00", "17:00:00-05:00", etc.
	 */
	open: string;

	/**
	 * The time the support line closes.
	 */
	close: string;
}

export type SupportSchedule = Partial<Record<DayOfWeek, SupportHours>>;